// userMasterSettings.js
const UserSetting = (() => {
  // Private settings object
  let settings = {
    credit_Settlement: false,
    showAcBal: false,
    can_flag: false,
    print_report: false,
    adjustPurRate: false,
    modJobRate: false,
    adjustSaleRate: false,
    rate_in_sale: false,
    flags: "", // Store flag ids assign to user "1; 2;"
  };

  return {
    setSettings(newSettings) {
      settings = {
        credit_Settlement: newSettings.credit_Settlement,
        showAcBal: newSettings.showAcBal,
        can_flag: newSettings.can_flag,
        print_report: newSettings.print_report,
        adjustPurRate: newSettings.adjustPurRate,
        modJobRate: newSettings.modJobRate,
        adjustSaleRate: newSettings.adjustSaleRate,
        rate_in_sale: newSettings.rate_in_sale,
        flags: newSettings.flags,
      };
    },

    //   getSettings() {
    //     return { ...settings }; // Return a copy to prevent direct modification
    //   },

    // Method to return all settings as a string
    toString() {
      return Object.entries(settings)
        .map(([key, value]) => `${key}: ${value}`)
        .join(", ");
    },

    canIssue() {
      return settings.credit_Settlement;
    },
    canChangeWorker() {
      return settings.showAcBal;
    },
    canChangeFlag() {
      return settings.can_flag;
    },
    canChangeFlagRemark() {
      return settings.print_report;
    },
    canChangePayForQty() {
      return settings.adjustPurRate;
    },
    canModifyJobRate() {
      return settings.modJobRate;
    },
    canModifyRemarks() {
      return settings.adjustSaleRate;
    },
    canModifySlipNotes() {
      return settings.rate_in_sale;
    },
    getFlags() {
      return settings.flags;
    },
  };
})();

export default UserSetting;
